import React, { useEffect } from "react";
import { useOneLoginFlow } from "../hooks";
import { useAuthContext } from "../hooks/useAuthContext";
/**
 * Login component.
 * Redirects to OneLogin login page.
 * Displays children while redirect is in progress.
 * Displays an error message and a retry button on error.
 *
 * @copyright 2021 Noom, Inc.
 * @author nikola
 */
export function Login({ callbackPath = "/login/callback", children, }) {
    var _a, _b;
    const { login, error } = useOneLoginFlow();
    const { fallback } = (_a = useAuthContext()) !== null && _a !== void 0 ? _a : {};
    useEffect(() => {
        if (!error) {
            login(callbackPath);
        }
    }, []);
    return (React.createElement(React.Fragment, null,
        !error && ((_b = children !== null && children !== void 0 ? children : fallback) !== null && _b !== void 0 ? _b : React.createElement("div", null, "Login in progress...")),
        error && (React.createElement(React.Fragment, null,
            React.createElement("span", { style: { color: "red" } },
                "Login error : ",
                error.type,
                " : ",
                error.message),
            " ",
            React.createElement("button", { type: "button", onClick: () => {
                    login(callbackPath);
                } }, "Retry")))));
}
export default Login;
//# sourceMappingURL=Login.js.map